import { Presentation } from "lucide-react";

export const StrategyIcon = ({
  size = 24,
  color = 'currentColor',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.83073 3.25V15.4375C3.83073 16.7837 4.95002 17.875 6.33073 17.875H8.83073M3.83073 3.25H2.16406M3.83073 3.25H22.1641M22.1641 3.25H23.8307M22.1641 3.25V15.4375C22.1641 16.7837 21.0448 17.875 19.6641 17.875H17.1641M8.83073 17.875H17.1641M8.83073 17.875L7.71962 21.125M17.1641 17.875L18.2752 21.125M18.2752 21.125L18.8307 22.75M18.2752 21.125H7.71962M7.71962 21.125L7.16406 22.75M9.66406 12.1875V13.8125M12.9974 9.75V13.8125M16.3307 7.3125V13.8125"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    // <Presentation stroke="var(--color-policy-orange)" strokeWidth={1.5} />
  );
};

export default StrategyIcon;
